// NB: keep in sync with server side.
export enum SignupStatus {
	Success = 1,
	HasErrors,
	FailedToSendConfirmationEmail
}